import { Injectable } from '@angular/core';

import { Observable, debounceTime, map, tap, filter } from 'rxjs';

import { ApiClientService } from '@tablesready/api-client';
import { AuthRestaurantService } from '@tablesready/frontend-store';

@Injectable({providedIn: 'root'})
export class WaitTimeService {
  currentWait: number = 0;
  defaultWait: number = 0;
  lastUpdated: number = Date.now();

  constructor(
    private readonly http: ApiClientService,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {
  }

  init() {
    return this.authRestaurantService.select()
      .pipe(
        filter(({location}) => !!location),
        tap(({location}) => {
          this.currentWait = location.default_quoted_time;
          this.defaultWait = location.default_quoted_time;
          this.lastUpdated = Date.now();
        }),
      );
  }

  setTime(currentTime: number, defaultTime?: number) {
    this.currentWait = currentTime;
    if (defaultTime) {
      this.defaultWait = currentTime;
    }
    this.lastUpdated = Date.now();
  }

  getTime() {
    if (this.lastUpdated <= Date.now() - 1000 * 60 * 2 * this.currentWait) {
      return this.defaultWait;
    }
    return this.currentWait;
  }

  getEstimates(waitingParties): Observable<any> {
    return this.http.post<any>('/v.1/who/estimatedWait', { waitingParties }).pipe(
      debounceTime(1000),
      map(({ data, success, error }) => {
        if (success) {
          return data;
        } else {
          throw new Error(`${error}`);
        }
      }),
    );
  }
}
